export default function shiftRight(arr) {
  let tmpArr = [...arr];
  let last = tmpArr.pop();
  tmpArr.unshift(last);
  return tmpArr;
}
